// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"436":"393152ff","636":"bbd62b7f"}[chunkId] + ".js";
};